import { ref } from 'vue';
import type { Ref } from 'vue';
import { useLocalStorage, useSessionStorage } from '@vueuse/core';

export type BcxPersistenceMode = 'localStorage' | 'sessionStorage' | 'none';

export function createStorageBackedRef<T>(storageKey: string, initialValue: T, persistenceMode: BcxPersistenceMode): Ref<T> {
  switch (persistenceMode) {
    case 'sessionStorage':
      return useSessionStorage(storageKey, initialValue);
    case 'localStorage':
      return useLocalStorage(storageKey, initialValue);
    case 'none':
    default:
      return ref(initialValue) as Ref<T>;
  }
}
